<template>
  <JobMatrixMgr />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
